import { Divider, Grid, useEventCallback } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import ListGender from 'shell/components/shared/gender';
import { DatePicker } from '@mui/lab';
import { memo, useMemo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { DocumentMarriageFormVM } from 'civil-status/view-models/document-birth-form';
import MatricolaList from './matricola-list';
import { PageMode } from 'civil-status/view-models/page-mode';
import ListCivilStatus from './list-civil-status';

interface DocumentMarriageFormProps {
  values?: DocumentMarriageFormVM;
  errors?: FormikErrors<DocumentMarriageFormVM>;
  touched?: FormikTouched<DocumentMarriageFormVM>;
  onChange: (
    key: keyof DocumentMarriageFormVM,
    value: DocumentMarriageFormVM[keyof DocumentMarriageFormVM]
  ) => void;
  onChanges: (values: DocumentMarriageFormVM) => void;
  mode: PageMode;
}

const DocumenMarriageFormComponent = ({
  values,
  touched,
  errors,
  mode,
  onChange,
  onChanges,
}: DocumentMarriageFormProps): React.ReactElement => {
  const disabled = useMemo(() => {
    return mode === PageMode.Detail;
  }, [mode]);

  const handleCivilStatusListHusbandChange = useEventCallback((element: string | undefined) => {
    onChange('statusHusband', element);
  });

  const handleCivilStatusListWifeChange = useEventCallback((element: string | undefined) => {
    onChange('statusWife', element);
  });

  return (
    <>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={4}>
          <DatePicker
            label="Data matrimonio"
            aria-label="Data matrimonio"
            value={values?.marriageDate || null}
            disabled={disabled}
            onChange={(value) => onChange('marriageDate', value)}
            renderInput={(params) => (
              <PmiTextField
                id="marriageDate"
                name="marriageDate"
                {...params}
                fullWidth
                error={touched?.marriageDate && Boolean(errors?.marriageDate)}
                helperText={errors?.marriageDate}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={8}>
          <PmiTextField
            aria-label="Comune matrimonio"
            label="Comune matrimonio"
            id="marriageMunicipality"
            name="marriageMunicipality"
            fullWidth
            disabled={disabled}
            value={values?.marriageMunicipality || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('marriageMunicipality', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('marriageMunicipality', event?.target.value);
            }}
            error={touched?.marriageMunicipality && Boolean(errors?.marriageMunicipality)}
            helperText={errors?.marriageMunicipality}
          />
          {/* <span>F2 per Milano</span> */}
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ paddingTop: '10px' }}>
        <Divider />
      </Grid>
      {/* <Grid item xs={12} style={{ paddingTop: '10px' }}>
        <PmiTitleDivider>Marito</PmiTitleDivider>
      </Grid> */}
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <MatricolaList
            aria-label="Matricola"
            label="Matricola"
            id="matricolaHusband"
            disabled={disabled}
            surname={values?.surnameHusband || ''}
            name={values?.nameHusband || ''}
            value={values?.matricolaHusband || ''}
            dateBirth={values?.birthdayHusband || null}
            onChanges={(value) =>
              onChanges({
                matricolaHusband: value.matricola,
                birthdayHusband: value.birthday,
                genderHusband: value.gender,
                nameHusband: value.name,
                surnameHusband: value.surname,
              })
            }
            error={touched?.matricolaHusband && Boolean(errors?.matricolaHusband)}
            isSmallSize
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome"
            label={`Cognome ${mode === PageMode.Edit ? '*' : ''}`}
            id="surnameHusband"
            name="surnameHusband"
            fullWidth
            disabled={disabled}
            value={values?.surnameHusband || ''}
            onChange={(event) => onChange('surnameHusband', event?.target.value)}
            error={touched?.surnameHusband && Boolean(errors?.surnameHusband)}
            helperText={errors?.surnameHusband}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Nome"
            label={`Nome ${mode === PageMode.Edit ? '*' : ''}`}
            id="nameHusband"
            name="nameHusband"
            fullWidth
            disabled={disabled}
            value={values?.nameHusband || ''}
            onChange={(event) => onChange('nameHusband', event?.target.value)}
            error={touched?.nameHusband && Boolean(errors?.nameHusband)}
            helperText={errors?.nameHusband}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={3}>
          <ListGender
            value={values?.genderHusband || ''}
            onChange={(event) => onChange('genderHusband', event?.target.value)}
            error={touched?.genderHusband && Boolean(errors?.genderHusband)}
            disabled={disabled}
            isSmallSize
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={4}>
          <DatePicker
            label="Data nascita"
            aria-label="Data nascita"
            value={values?.birthdayHusband || null}
            disabled={disabled}
            onChange={(value) => onChange('birthdayHusband', value)}
            renderInput={(params) => (
              <PmiTextField
                id="birthdayHusband"
                name="birthdayHusband"
                {...params}
                fullWidth
                error={touched?.birthdayHusband && Boolean(errors?.birthdayHusband)}
                helperText={errors?.birthdayHusband}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={2}>
          <PmiTextField
            aria-label="Anni"
            label="Anni"
            id="year"
            name="years"
            fullWidth
            disabled={disabled}
            value={values?.yearsHusband || ''}
            onChange={(event) => onChange('yearsHusband', event?.target.value)}
            error={touched?.yearsHusband && Boolean(errors?.yearsHusband)}
            helperText={errors?.yearsHusband}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={3}>
          <PmiTextField
            aria-label="Anno nascita"
            label="Anno nascita"
            id="year-birth"
            name="year-birth"
            fullWidth
            disabled={disabled}
            value={values?.yearDateHusband || ''}
            onChange={(event) => onChange('yearDateHusband', event?.target.value)}
            error={touched?.yearDateHusband && Boolean(errors?.yearDateHusband)}
            helperText={errors?.yearDateHusband}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune nascita"
            label="Comune nascita"
            id="municipalityBirthHusband"
            name="municipalityBirthHusband"
            fullWidth
            disabled={disabled}
            value={values?.municipalityBirthHusband || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('municipalityBirthHusband', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('municipalityBirthHusband', event?.target.value);
            }}
            error={touched?.municipalityBirthHusband && Boolean(errors?.municipalityBirthHusband)}
            helperText={errors?.municipalityBirthHusband}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} md={9} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune residenza"
            label="Comune residenza"
            id="residenceMunicipalityHusband"
            name="residenceMunicipalityHusband"
            fullWidth
            disabled={disabled}
            value={values?.residenceMunicipalityHusband || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('residenceMunicipalityHusband', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('residenceMunicipalityHusband', event?.target.value);
            }}
            error={
              touched?.residenceMunicipalityHusband && Boolean(errors?.residenceMunicipalityHusband)
            }
            helperText={errors?.residenceMunicipalityHusband}
          />
        </Grid>
        <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
          <span>F2 per Milano</span>
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={7}>
          <PmiTextField
            label="Cittadinanza"
            aria-label="Cittadinanza"
            id="citizenship-h"
            name="citizenship-h"
            fullWidth
            value={values?.citizenshipHusband || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('citizenshipHusband', 'ITALIANA');
                return;
              }
            }}
            disabled={disabled}
            onChange={(event) => onChange('citizenshipHusband', event.target.value)}
            error={touched?.citizenshipHusband && Boolean(errors?.citizenshipHusband)}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={5}>
          <ListCivilStatus
            id="civil-status-h"
            value={values?.statusHusband || ''}
            disabled={disabled}
            onChange={(event) => handleCivilStatusListHusbandChange(event.target.value)}
            error={touched?.statusHusband && Boolean(errors?.statusHusband)}
          />
        </Grid>
        {/* <span>F2 per Italiana</span> */}
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome post matrimonio"
            label="Cognome post matrimonio"
            id="surnameAfterMarriageHusband"
            name="surnameAfterMarriageHusband"
            fullWidth
            disabled={disabled}
            value={values?.surnameAfterMarriageHusband || ''}
            onChange={(event) => onChange('surnameAfterMarriageHusband', event?.target.value)}
            error={
              touched?.surnameAfterMarriageHusband && Boolean(errors?.surnameAfterMarriageHusband)
            }
            helperText={errors?.surnameAfterMarriageHusband}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ paddingTop: '10px' }}>
        <Divider />
      </Grid>
      {/* <Grid item xs={12} style={{ paddingTop: '10px' }}>
        <PmiTitleDivider>Moglie</PmiTitleDivider>
      </Grid> */}
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <MatricolaList
            aria-label="Matricola"
            label="Matricola"
            id="matricolaWife"
            surname={values?.surnameWife || ''}
            name={values?.nameWife || ''}
            dateBirth={values?.birthdayWife || null}
            disabled={disabled}
            value={values?.matricolaWife || ''}
            onChanges={(value) =>
              onChanges({
                matricolaWife: value.matricola,
                birthdayWife: value.birthday,
                genderWife: value.gender,
                nameWife: value.name,
                surnameWife: value.surname,
              })
            }
            error={touched?.matricolaWife && Boolean(errors?.matricolaWife)}
            isSmallSize
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome"
            label={`Cognome ${mode === PageMode.Edit ? '*' : ''}`}
            id="surnameWife"
            name="surnameWife"
            fullWidth
            disabled={disabled}
            value={values?.surnameWife || ''}
            onChange={(event) => onChange('surnameWife', event?.target.value)}
            error={touched?.surnameWife && Boolean(errors?.surnameWife)}
            helperText={errors?.surnameWife}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Nome"
            label={`Nome ${mode === PageMode.Edit ? '*' : ''}`}
            id="nameWife"
            name="nameWife"
            fullWidth
            disabled={disabled}
            value={values?.nameWife || ''}
            onChange={(event) => onChange('nameWife', event?.target.value)}
            error={touched?.nameWife && Boolean(errors?.nameWife)}
            helperText={errors?.nameWife}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={3}>
          <ListGender
            value={values?.genderWife || ''}
            onChange={(event) => onChange('genderWife', event?.target.value)}
            error={touched?.genderWife && Boolean(errors?.genderWife)}
            disabled={disabled}
            isSmallSize
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={4}>
          <DatePicker
            label="Data nascita"
            aria-label="Data nascita"
            value={values?.birthdayWife || null}
            disabled={disabled}
            onChange={(value) => onChange('birthdayWife', value)}
            renderInput={(params) => (
              <PmiTextField
                id="birthdayWife"
                name="birthdayWife"
                {...params}
                fullWidth
                error={touched?.birthdayWife && Boolean(errors?.birthdayWife)}
                helperText={errors?.birthdayWife}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={2}>
          <PmiTextField
            aria-label="Anni"
            label="Anni"
            id="year"
            name="years"
            fullWidth
            disabled={disabled}
            value={values?.yearsWife || ''}
            onChange={(event) => onChange('yearsWife', event?.target.value)}
            error={touched?.yearsWife && Boolean(errors?.yearsWife)}
            helperText={errors?.yearsWife}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={3}>
          <PmiTextField
            aria-label="Anno nascita"
            label="Anno nascita"
            id="year-birth"
            name="year-birth"
            fullWidth
            disabled={disabled}
            value={values?.yearDateWife || ''}
            onChange={(event) => onChange('yearDateWife', event?.target.value)}
            error={touched?.yearDateWife && Boolean(errors?.yearDateWife)}
            helperText={errors?.yearDateWife}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune nascita"
            label="Comune nascita"
            id="municipalityBirthWife"
            name="municipalityBirthWife"
            fullWidth
            disabled={disabled}
            value={values?.municipalityBirthWife || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('municipalityBirthWife', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('municipalityBirthWife', event?.target.value);
            }}
            error={touched?.municipalityBirthWife && Boolean(errors?.municipalityBirthWife)}
            helperText={errors?.municipalityBirthWife}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} md={9} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune residenza"
            label="Comune residenza"
            id="residenceMunicipalityWife"
            name="residenceMunicipalityWife"
            fullWidth
            disabled={disabled}
            value={values?.residenceMunicipalityWife || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('residenceMunicipalityWife', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('residenceMunicipalityWife', event?.target.value);
            }}
            error={touched?.residenceMunicipalityWife && Boolean(errors?.residenceMunicipalityWife)}
            helperText={errors?.residenceMunicipalityWife}
          />
        </Grid>
        <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
          <span>F2 per Milano</span>
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={7}>
          <PmiTextField
            label="Cittadinanza"
            aria-label="Cittadinanza"
            id="citizenship-w"
            name="citizenship-w"
            fullWidth
            value={values?.citizenshipWife || ''}
            disabled={disabled}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('citizenshipWife', 'ITALIANA');
                return;
              }
            }}
            onChange={(event) => onChange('citizenshipWife', event.target.value)}
            error={touched?.citizenshipWife && Boolean(errors?.citizenshipWife)}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={5}>
          <ListCivilStatus
            id="civil-status-w"
            value={values?.statusWife || ''}
            disabled={disabled}
            onChange={(event) => handleCivilStatusListWifeChange(event.target.value)}
            error={touched?.statusWife && Boolean(errors?.statusWife)}
          />
        </Grid>
        {/* <span>F2 per Italiana</span> */}
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome post matrimonio"
            label="Cognome post matrimonio"
            id="surnameAfterMarriageWife"
            name="surnameAfterMarriageWife"
            fullWidth
            disabled={disabled}
            value={values?.surnameAfterMarriageWife || ''}
            onChange={(event) => onChange('surnameAfterMarriageWife', event?.target.value)}
            error={touched?.surnameAfterMarriageWife && Boolean(errors?.surnameAfterMarriageWife)}
            helperText={errors?.surnameAfterMarriageWife}
          />
        </Grid>
      </Grid>
    </>
  );
};

DocumenMarriageFormComponent.displayName = 'Document Marriage form component';

const DocumentMarriageFormShared = memo(DocumenMarriageFormComponent);

export default DocumentMarriageFormShared;
